import { motion } from "framer-motion";
import { AuthLogo } from "../components/AuthLogo";
import { RegisterForm } from "../form/RegisterForm";
import { EncryptedText } from "../../../components/ui/animated/EncriptedText";
import registerBg from "../assets/images/register-background.webp";
import logoImg from "../assets/images/logo.webp";

interface RegisterPageProps {
  title?: string;
  description?: string;
}

export const RegisterPage = ({
  title = "Register",
  description = "Creează-ți un cont nou pentru a accesa toate funcționalitățile platformei Atlantis.",
}: RegisterPageProps) => {
  return (
    <div
      className="relative min-h-screen w-full overflow-hidden chakra-petch-font"
      aria-label="Register page"
    >
      {/* Background image */}
      {registerBg && (
        <div
          className="absolute inset-0 bg-cover bg-right bg-no-repeat"
          style={{ backgroundImage: `url(${registerBg})` }}
          aria-hidden="true"
        />
      )}

      {/* Content panel */}
      <div className="min-h-screen flex items-center">
        <main className="relative z-10 flex pl-[130px]">
          <motion.div
            className="flex flex-col justify-center max-w-[450px]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            {/** Border left */}
            <div className="w-[1px] h-full absolute top-0 bottom-0 left-[65px] bg-[#D9D9D9]/10 flex flex-col justify-between">
              <div className="w-full h-[8px] bg-white"></div>
              <div className="w-full h-[8px] bg-white"></div>
            </div>

            {/* Logo */}
            <div>
              <AuthLogo src={logoImg} alt={"logo"} />
            </div>

            {/* Welcome header */}
            <motion.div
              className="mt-14 mb-9 flex flex-col gap-3"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.5, ease: "easeOut" }}
            >
              <h1
                style={{
                  color: "#fff",
                  textShadow: "0 2px 4px rgba(255,255,255,0.6)",
                  fontWeight: "bold",
                }}
                className="text-white text-[65px] uppercase tracking-wide bebas-neue-font leading-[0.6]"
              >
                <EncryptedText text={title} flipDelayMs={5} />
              </h1>
              <p className="text-[#FFFFFF]/50 text-sm">
                <EncryptedText text={description} revealDelayMs={10} />
              </p>
            </motion.div>

            {/* Register form */}
            <RegisterForm onSubmit={async () => {}} />
          </motion.div>
        </main>
      </div>
    </div>
  );
};
